export function replaceNbspFromHtml<T>(text: T): T {
  if (typeof text !== 'string') {
    return text;
  }

  const NBSP_CHAR_CODE = 160;
  const nbspCharRegex = new RegExp(String.fromCharCode(NBSP_CHAR_CODE), 'g');
  const nbspRegex = /&nbsp;/g;

  return text
    .replace(nbspCharRegex, ' ')
    .replace(nbspRegex, ' ') as T;
}
